// Asset URLs provided by the user.
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_dentro-landing/artifacts/9712qx9z_WhatsApp%20Image%202026-04-19%20at%2000.14.52.jpeg";

export const SCREEN_FILTER =
    "https://customer-assets.emergentagent.com/job_dentro-landing/artifacts/4gad3oej_WhatsApp%20Image%202026-04-19%20at%2000.17.13.jpeg";

export const SCREEN_ANALYSIS =
    "https://customer-assets.emergentagent.com/job_dentro-landing/artifacts/tal5jdla_WhatsApp%20Image%202026-04-19%20at%2000.16.55.jpeg";

export const SCREEN_GOALS =
    "https://customer-assets.emergentagent.com/job_dentro-landing/artifacts/y3kskly8_WhatsApp%20Image%202026-04-19%20at%2000.17.03.jpeg";
